import axios from 'axios';
import localStorageHelper from '@/helpers/localStorageHelper';

const AUTH_TOKEN_KEY = 'AUTH_TOKEN';
const AUTH_TOKEN_TYPE = 'AUTH_TOKEN_TYPE';
const USER_NAME = 'USER_NAME';
// const PHONE_NUMBER = 'PHONE_NUMBER';
const USER_AUTH_INFO_KEY = 'USER_AUTH_INFO';

export default class AuthQuery {
  static login(username, password) {
    return axios.post('/api/old_login', {
      phoneNumber: username,
      password
    },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(success => {
      // console.log(success);
      // write token into local storage (or cookie)
      // localStorageHelper.setItem(AUTH_TOKEN_KEY, success.data.token);
      // localStorageHelper.setItem(USER_NAME, username);
      return Promise.resolve(success);
    }, (error) => {
      // localStorageHelper.removeItem(AUTH_TOKEN_KEY);
      // localStorageHelper.removeItem(USER_NAME);
      return Promise.reject(error);
    });
  }
  static getVerifyCode(phoneNumber) {
    return axios.post('/api/sms', {
      phoneNumber
    }).then(result => {
      return result.data;
    }, (err) => {
      return Promise.reject(err);
    });
  }

  static registerAccount(phoneNumber, password, verifyCode) {
    return axios.post('/api/signup', {
      phoneNumber,
      password,
      verifyCode
    }).then(success => {
      // write token into local storage (or cookie)
      localStorageHelper.setItem(AUTH_TOKEN_KEY, success.data.token);
      localStorageHelper.setItem(USER_NAME, phoneNumber);
      return Promise.resolve(success);
    }, (error) => {
      localStorageHelper.removeItem(AUTH_TOKEN_KEY);
      localStorageHelper.removeItem(USER_NAME);
      return Promise.reject(error.response.data);
    });
  }
  static logout(username) {
    return axios.delete(`/v1/api/logout/${username}`).then(success => {
      // write token into local storage (or cookie)
      localStorageHelper.removeItem(AUTH_TOKEN_KEY);
      localStorageHelper.removeItem(AUTH_TOKEN_TYPE);
      // localStorageHelper.removeItem(USER_NAME);
      // localStorageHelper.removeItem(PHONE_NUMBER);
      localStorageHelper.removeItem(USER_AUTH_INFO_KEY); // clear auth info to prevent next auto login
      return Promise.resolve(success);
    }, (error) => {
      localStorageHelper.removeItem(AUTH_TOKEN_KEY);
      localStorageHelper.removeItem(AUTH_TOKEN_TYPE);
      // localStorageHelper.removeItem(USER_NAME);
      // localStorageHelper.removeItem(PHONE_NUMBER);
      localStorageHelper.removeItem(USER_AUTH_INFO_KEY); // clear auth info to prevent next auto login
      return Promise.reject(error);
    });
  }

  // 新登录
  static verifycode(telNumber) {
    return axios.get(`/v1/api/verifyCode/${telNumber}`).then(res => {
      return res.data || {};
    },
    (err) => {
      return Promise.reject(err);
    });
  }
  
  static verifyLogin(phone, verifyCode, autoLogin) {
    return axios.post('/v1/api/login', { phone, verifyCode, autoLogin }).then(res => {
      return res.data || {};
    }, (err) => {
      return Promise.reject(err);
    });
  }

  static passwordLogin(phone, password, autoLogin) {
    return axios.post('/v1/api/loginPass', { phone, password, autoLogin }).then(res => {
      return res.data || {};
    }, (err) => {
      return Promise.reject(err);
    });
  }

  static setPass(phone, password) {
    return axios.post('/v1/api/setPass', { phone, password }).then(res => {
      return res.data || {};
    }, (err) => {
      return Promise.reject(err);
    });
  }

  static hasPass(phone) {
    return axios.post('/v1/api/hasPass', { phone }).then(res => {
      return res.data || {};
    }, (err) => {
      return Promise.reject(err);
    });
  }
  
  static setUsername(telNumber, username) {
    return axios.post('/api/set_username', { telNumber, username }).then(res => {
      return res.data || {};
    }, (err) => {
      return Promise.reject(err);
    });
  }
  
  static perfectUserMessage(telNumber, verificationCode, username) {
    return axios.post('/api/perfect_user_message', { telNumber, verificationCode, username }).then(res => {
      return res.data || {};
    }, (err) => {
      return Promise.reject(err);
    });
  }
}

